import SeoPage from "./SeoPage";

export default function CompressMp4Under25() {
    return (
        <SeoPage
            heading="Compress MP4 Under 25MB"
            intro="Compress MP4 videos under 25MB online instantly. Ideal for email, forms, and uploads."
            title="Compress MP4 Under 25MB – TinyCompression"
            description="Compress MP4 under 25MB for free using TinyCompression. No signup, Reliable compression, and secure processing."
        />
    );
}
